/**
 * Conversiones pixel <-> coordenadas normalizadas para overlays en el visor PDF.
 * Extraido de configuracion-documento-upload (convertirCoordAGuardar* / convertirCoordMostrar*).
 * Fase 2 del refactor formulario-documento.
 */

export interface MedidaPdf {
  anchura: number;
  altura: number;
}

export interface RectPixel {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface RectNormalized {
  posicionTop: number;
  posicionLeft: number;
  posicionRight: number;
  posicionHeight: number;
  posicionWidth: number;
}

/** Offset vertical en pantalla al pintar (scroll/header del visor). */
export const OVERLAY_TOP_OFFSET_PX = 50;

/**
 * Origen (esquina superior izquierda del `.pdf-container`) en coordenadas de
 * pantalla que se resta al soltar un gadget para obtener su posicion relativa al PDF.
 *
 * En el wizard estandar el `.pdf-container` esta en una posicion fija de pantalla
 * (estos valores historicos). En Envio simple la vista previa vive en otra columna,
 * por lo que el origen se calcula en vivo desde `docPosition` (medido del area PDF):
 * `left = docPosition.left`, `top = docPosition.top - barra de controles`.
 */
export const DROP_ORIGIN_LEFT_LEGACY = 81;
export const DROP_ORIGIN_TOP_LEGACY = 100;

export function dropOrigin(
  modoEnvioSimple: boolean,
  docPosition?: { left: number; top: number } | null
): { left: number; top: number } {
  if (modoEnvioSimple && docPosition) {
    return { left: docPosition.left, top: docPosition.top - OVERLAY_TOP_OFFSET_PX };
  }
  return { left: DROP_ORIGIN_LEFT_LEGACY, top: DROP_ORIGIN_TOP_LEGACY };
}

export function pixelRectToNormalized(
  rect: RectPixel,
  medida: MedidaPdf,
  topOffsetPx: number = OVERLAY_TOP_OFFSET_PX
): RectNormalized {
  return {
    posicionTop: (rect.y - topOffsetPx) / medida.altura,
    posicionLeft: rect.x / medida.anchura,
    posicionRight: (rect.x + rect.width) / medida.anchura,
    posicionHeight: rect.height / medida.altura,
    posicionWidth: rect.width / medida.anchura,
  };
}

export function normalizedRectToPixel(
  norm: Pick<RectNormalized, 'posicionTop' | 'posicionLeft' | 'posicionWidth' | 'posicionHeight'>,
  medida: MedidaPdf,
  topOffsetPx: number = OVERLAY_TOP_OFFSET_PX
): RectPixel {
  return {
    x: norm.posicionLeft * medida.anchura,
    y: norm.posicionTop * medida.altura + topOffsetPx,
    width: norm.posicionWidth * medida.anchura,
    height: norm.posicionHeight * medida.altura,
  };
}

/** Tamaño visual del overlay en pantalla (incluye borde); evita pérdida de px respecto a clientWidth. */
export function overlayElementSize(el: HTMLElement): Pick<RectPixel, 'width' | 'height'> {
  return {
    width: el.offsetWidth || el.clientWidth,
    height: el.offsetHeight || el.clientHeight,
  };
}